export enum DeviceType {
  Web = 'web',
  IOS = 'ios',
  Android = 'android',
}
